import _ from 'lodash';
import { useContext, useMemo } from 'react';
import { Segment } from 'semantic-ui-react';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { PageAreaContext } from '../cnr/contexts/PageAreaContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { uniqueKey } from '../common/keys';
import FullPageContent from '../components/layout/FullPageContent';
import IconGrids from '../components/layout/IconGrids';
import ListGrid from '../components/layout/ListGrid';
import { clickOriginTypes, gEnums } from '../enums/globalEnums';
import PageItem, { PageItem_withProvider } from './PageItem';
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';

// < PageAreaContent 
// > PageContent 
// > PageItem 
// > UiItem 
// > SemUi 
// > SemElems 
// > SemCardsWithProvider

/**
 * 
 * @returns a list of 'PageItem' for each pageItemsActive or IconGrids
 */
const PageContent = () => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, page_state, paps_state } = states
  const { pathViews } = paps_state ?? {}

  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { viewItems: viewItems_page, trueView } = aps_page ?? {}

  useRenders('PageContent', true, true)

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { desktopMode, showFullPage, fullPageType } = framework_state ?? {}
  const { handleShow_fullPage } = framework_handlers ?? {}

  // pageContext   
  const { layout: layout_page, desktopLayout: desktopLayout_page } = aps_page ?? {}
  const _layout = desktopMode ? desktopLayout_page : layout_page
  const { layoutType } = _layout ?? {}

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsActive, uiGroupedItems, uiSelectedItems, fixFirstViewItem, gridTemplateRows } = pageArea_state ?? {}

  const getPageItemInfo = (uivi) => {
    const viewItem_page = pageItemsActive[uivi]
    const viewItem_app = aps_viewItems[uivi]
    const { display, desktopDisplay } = viewItem_page ?? {}
    const _display = desktopMode && desktopDisplay ? desktopDisplay : display
    const { caption } = _display ?? {}
    return { uivi, viewItem: viewItem_page, viewItem_app, display: _display, caption }
  }

  let isSinglePage;

  switch (layoutType) {
    case gEnums.layoutTypes.singlePage:
      isSinglePage = true
    default:
    // nothing
  }

  const pageItemsContent = () => {

    if (_.isEmpty(pageItemsActive)) {
      return (
        <Segment basic>
          No Page Items are set to 'show'. Check the 'Page Items' settings.
        </Segment>
      );
    }

    return _.map(pageItemsActive, (value, uivi) => {
      if (isSinglePage || desktopMode) {
        const vip = getPageItemInfo(uivi);
        return (
          <PageItem_withProvider
            key={uniqueKey('pcpic', uivi)}
            uivi={uivi}
            caption={vip.caption}
            viewItem_app={vip.viewItem_app}
          />
        );
      } else {
        return (
          <PageItem_withProvider
            key={uniqueKey('pcpic', uivi)}
            uivi={uivi}
            from="PageContent"
          />
        );
      }
    });
  };

  // IMPORTANT: UI - layoutType - build the correct UI content based on the viewType
  const content = useMemo(() => {
    if (showFullPage && fullPageType) {
      return (
        <FullPageContent
          fullPageType={fullPageType}
          handleCancel={handleShow_fullPage}
          clickOriginType={clickOriginTypes.iconGrid}
        />
      );
    }

    if (pageItemsActive) {

      switch (layoutType) {
        case gEnums.layoutTypes.golfTournament:
          return <div>Golf Tournament</div>;

        case gEnums.layoutTypes.pageList:
          const visl = getGroupVis(uiSelectedItems, aps_viewItems);
          return <ListGrid
            key={uniqueKey('pcpic', 'pl')}
            selectedItems={visl}
          />;

        case gEnums.layoutTypes.pageIcons:
          const vis = getGroupVis(uiGroupedItems, aps_viewItems);
          return <IconGrids
            key={uniqueKey('pcpic', 'pi')}
            pageIcons={vis}
          />;

        case gEnums.layoutTypes.icons:
          return <IconGrids key={uniqueKey('pcpic', 'icn')} />;

        case gEnums.layoutTypes.horizontalSliders:
          return (
            <div className="horizontal-container">
              {pageItemsContent()}
            </div>
          );

        case gEnums.layoutTypes.singlePage:
          let cn = 'single-page-container';
          if (fixFirstViewItem) { cn += ' fix-first'; }
          const sty = gridTemplateRows ? { gridTemplateRows } : {};
          return (
            <div
              className={cn}
              style={sty}
              id={cn}
              name={cn}
            >
              {pageItemsContent()}
            </div>
          );

        case gEnums.layoutTypes.swipeable:
        case gEnums.layoutTypes.swipeableHidden:
          return pageItemsContent();

        default:
          return pageItemsContent();
      }
    }
    return <div>{'NO pageItemsActive'}</div>;
  }, [
    aps_viewItems,
    fixFirstViewItem,
    fullPageType,
    fullPageType,
    gridTemplateRows,
    layoutType,
    viewItems_page,
    pathViews,
    showFullPage,
    showFullPage,
    uiGroupedItems,
    uiSelectedItems,
    trueView,
  ]);

  return content

}

const getGroupVis = (pageIcons, aps_viewItems) => {
  const groupVis = {}
  if (pageIcons) {
    pageIcons.forEach((gi, index) => {
      if (aps_viewItems && aps_viewItems[gi]) {
        groupVis[gi] = {
          position: index,
          show: true,
          key: gi,
          itemKey: gi,
          display: aps_viewItems[gi].display
        }
      }
    })
  }
  return groupVis
}

export default PageContent 